import { PaginateBlock } from '../components/PaginateBlock/PaginateBlock'
import TvGridRow from '../components/TvGridContainer/TvGridRow'
import { TvSearchGridRow } from '../components/TvSearchLayout/TvSearchGrid/TvSearchGridRow'
import { PAGINATION_BLOCK_HEIGHT } from '../constants/general'
import { LinkModelStylesEnum, LinkModelTypesEnum } from '../types/flo-enums'
import { TvGridContainerItem } from '../types/flo-experience'
import { CARD_SPACING, toCard } from './carouselUtils'

export const toRowRef = (i) => `Row-${i}`

export const toRowComponent = (row, i, isCardFadeInEnabled = true) => {
  const rowRef = toRowRef(i)
  const rowStyle = row?.[0]?.style

  if (rowStyle === LinkModelStylesEnum.Paginate || rowStyle === LinkModelStylesEnum.Open) {
    return {
      type: PaginateBlock,
      h: PAGINATION_BLOCK_HEIGHT,
      w: (w) => w,
      data: row[0],
      ref: rowRef,
    }
  } else {
    return {
      rowId: i,
      ref: rowRef,
      type: TvGridRow,
      isCardFadeInEnabled,
      data: row,
    }
  }
}

export const createGridRows = (data, columns, pageSize = 0, pageNumber = 0) => {
  if (pageNumber > 0) {
    const type = data?.[0]?.type
    const style = data?.[0]?.style
    const fillers = Array.from({ length: pageNumber * pageSize }, () => ({ type, style }))
    data.unshift(...fillers)
  }

  const pageLink = data.find(
    (item) =>
      item.style === LinkModelStylesEnum.Paginate || item.style === LinkModelStylesEnum.Open,
  )
  const items = data.filter((item) => {
    return item.type !== LinkModelTypesEnum.Link
  })

  let rows = []

  for (let i = 0; i < items.length; i += columns) {
    const row = items.slice(i, i + columns)
    rows.push(row)
  }

  if (pageLink) {
    rows.push([pageLink])
  }

  return {
    rows,
    hasPagination: pageLink ? true : false,
  }
}

export const toSearchRowComponent = (
  row: TvGridContainerItem[],
  cardSize: { h: number; w: number },
  cols: number,
  index: number,
  isCardFadeInEnabled: boolean,
  cardStyle: string,
) => {
  const rowStyle = row?.[0].style
  if (rowStyle === LinkModelStylesEnum.Paginate || rowStyle === LinkModelStylesEnum.Open) {
    return {
      type: PaginateBlock,
      h: PAGINATION_BLOCK_HEIGHT,
      w: (w) => w,
      data: row[0],
      ref: toRowRef(index),
    }
  } else {
    return {
      type: TvSearchGridRow,
      h: cardSize.h + CARD_SPACING,
      w: cardSize.w * cols,
      ref: toRowRef(index),
      rowIndex: index,
      isCardFadeInEnabled,
      items: row?.map((item, i) => toCard(item, i, index, cardSize.h, cardSize.w, cardStyle)),
      flexItem: { marginBottom: CARD_SPACING },
    }
  }
}
